<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <h1>Deals</h1>
        <div class="d-flex justify-center flex-wrap mt-4">
          <v-chip to="/reporting/deals/company" class="mr-2" outlined pill medium active-class="active-chip"
            >Company</v-chip
          >
          <v-chip to="/reporting/deals/individual" class="mr-2" outlined pill medium active-class="active-chip">
            Individual
          </v-chip>
        </div>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="3">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Start Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="3">
        <v-menu
          ref="menu2"
          v-model="menu2"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="End Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="selectedDealOwners"
          :items="dealOwners"
          item-text="title"
          item-value="id"
          multiple
          label="Deal owners"
          chips
        />
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="selectedDealTypes"
          :items="dealTypes"
          item-text="title"
          item-value="id"
          multiple
          label="Deal type"
          chips
        />
      </v-col>
    </v-row>
    <router-view
      :start-date="startDate"
      :end-date="endDate"
      :deal-owners="selectedDealOwners"
      :deal-types="selectedDealTypes"
    />
  </v-container>
</template>

<script>
import { DEAL_OWNERS_QUERY, DEAL_TYPES_QUERY } from "@/graphql/queries/deal";

export default {
  name: "ReportingBase",
  data() {
    return {
      startDate: this.$moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      endDate: this.$moment().format("YYYY-MM-DD"),
      selectedDealOwners: [],
      selectedDealTypes: [],
      menu1: false,
      menu2: false,
    };
  },
  apollo: {
    dealOwners: {
      query: DEAL_OWNERS_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.dealOwners.map((obj) => ({ id: obj.user.id, title: `${obj.user.firstName} ${obj.user.lastName}` }));
      },
    },
    dealTypes: {
      query: DEAL_TYPES_QUERY,
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>

<style scoped>
.active-chip {
  color: var(--v-light-purple-base);
  border: 2px solid var(--v-green-base);
  font-weight: 600;
}
</style>
